import $ from 'jquery';


function menuImages() {
	var $elements  = $('.menu-item-image'),
	    $container = $('#slide-out-widget-area');
	
	// Loop through the elements and set up the menu-items
	$elements.each(function() {
		var $item  = $(this).parents('.menu-item'),
		    itemID = $item.attr('id'), 
				url    = $(this).attr('data-url');
		
		$(this).attr('data-item-id', itemID );
		
		$item.attr('data-url', url);
		
		$container.prepend($(this));
	})
	
	var $menuItems = $('.off-canvas-menu-container .menu-item[data-url]'),
	    $bgs			 = $('.menu-item-image');

	$menuItems.hover(function() {
		var url       = $(this).attr('data-url'),
		    id        = $(this).attr('id'),				
				$targetBg = $('.menu-item-image[data-item-id="' + id + '"]');
		
		if( $targetBg.length ) {
			url = 'url(' + url + ')';
			
			var bgImage = $targetBg.css('background-image');
			
			if( bgImage == 'none' ) {
				$targetBg.css('background-image', url);
			}
			$targetBg.fadeIn();	
		}
		
	}, function() {
		$bgs.fadeOut();
	});
}

export { menuImages } 